module.exports = __webpack_public_path__ + "img/gautier-capucon.db1dcdeb.jpg";